var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7073 2.87868C11.2699 2.31607 12.033 2 12.8286 2H19.0002C20.657 2 22.0002 3.34315 22.0002 5V11.1716C22.0002 11.9672 21.6841 12.7303 21.1215 13.2929L13.1215 21.2929C11.9499 22.4645 10.0504 22.4645 8.87887 21.2929L2.70729 15.1213C1.53572 13.9497 1.53572 12.0503 2.70729 10.8787L10.7073 2.87868ZM12.8286 4C12.5634 4 12.309 4.10536 12.1215 4.29289L4.12151 12.2929C3.73098 12.6834 3.73098 13.3166 4.12151 13.7071L10.2931 19.8787C10.6836 20.2692 11.3168 20.2692 11.7073 19.8787L19.7073 11.8787C19.8948 11.6911 20.0002 11.4368 20.0002 11.1716V5C20.0002 4.44772 19.5525 4 19.0002 4H12.8286Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 6.31653C19.0002 7.04363 18.4108 7.63306 17.6837 7.63306C16.9566 7.63306 16.3672 7.04363 16.3672 6.31653C16.3672 5.58943 16.9566 5 17.6837 5C18.4108 5 19.0002 5.58943 19.0002 6.31653Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2491 10.2247C11.1153 10.4397 11 10.9222 11 12C11 13.0778 11.1153 13.5603 11.2491 13.7753L11.2503 13.7772C11.2963 13.8513 11.3887 14 12 14C12.6113 14 12.7037 13.8513 12.7497 13.7772L12.7509 13.7753C12.8847 13.5603 13 13.0778 13 12C13 10.9222 12.8847 10.4397 12.7509 10.2247L12.7497 10.2228C12.7037 10.1487 12.6113 10 12 10C11.3887 10 11.2963 10.1487 11.2503 10.2228C11.2499 10.2234 11.2495 10.2241 11.2491 10.2247ZM9.55094 9.16813C10.1053 8.27721 11.0167 8 12 8C12.9833 8 13.8947 8.27721 14.4491 9.16813C14.9153 9.9174 15 10.9349 15 12C15 13.0651 14.9153 14.0826 14.4491 14.8319C13.8947 15.7228 12.9833 16 12 16C11.0167 16 10.1053 15.7228 9.55094 14.8319C9.08473 14.0826 9 13.0651 9 12C9 10.9349 9.08473 9.9174 9.55094 9.16813Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeDataIcon);
export default __webpack_public_path__ + "static/media/FreeDataIcon.3986dcf8545cdc585a3dd01bc62d49ae.svg";
export { ForwardRef as ReactComponent };